module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"calendar":"Calendar","bookings":"Bookings for property","guestbook":"Guestbook","locks":"Locks","invoices":"Invoices","reports":"Reports","settings":"Settings"},"sl":{"calendar":"Koledar","bookings":"Rezervacije","guestbook":"Knjiga gostov","locks":"Ključavnice","invoices":"Računi","reports":"Poročila","settings":"Nastavitve"}}')
  delete Component.options._Ctor
}
